import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100",
  id: "ScheduleCalendarContentTop"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "fw600" }, [
  /*#__PURE__*/_createTextVNode(" こちらの日程調整は現在キャンセルされています。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("同じメンバーで新規の日程調整を開始できます。 ")
], -1)
const _hoisted_5 = {
  key: 1,
  class: "mt40"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "fw600" }, "こちらの日程調整はキャンセルされています。", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "SelectableContent"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "fw600 fw14 mb10" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = { key: 5 }
const _hoisted_15 = {
  key: 6,
  class: "mb20"
}
const _hoisted_16 = {
  key: 7,
  class: "pad10 mt15"
}
const _hoisted_17 = {
  key: 0,
  class: "lskyblueBg rad12 dgrey w100 pad20 fs16 fw600"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "mt2 fs16" }
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 0,
  class: "w100"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 0,
  class: "fs12 alertBg rad3 pad5 centered fw600 mb20"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = {
  key: 2,
  style: {"margin-top":"10px"}
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, "調整カレンダーを編集して、候補を追加してください。", -1)
const _hoisted_33 = ["src"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw600" }, "  調整カレンダーを編集", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScheduleMainHeaderButton = _resolveComponent("ScheduleMainHeaderButton")!
  const _component_ScheduleMainEditableCalendarHeaderContent = _resolveComponent("ScheduleMainEditableCalendarHeaderContent")!
  const _component_ScheduleMainHeaderTitle = _resolveComponent("ScheduleMainHeaderTitle")!
  const _component_InstantRoomContent = _resolveComponent("InstantRoomContent")!
  const _component_SelectableLocations = _resolveComponent("SelectableLocations")!
  const _component_SelectableGroups = _resolveComponent("SelectableGroups")!
  const _component_ScheduleMainFixedAppoContent = _resolveComponent("ScheduleMainFixedAppoContent")!
  const _component_CalendarActionLargeButtons = _resolveComponent("CalendarActionLargeButtons")!
  const _component_ScheduleViewLoader = _resolveComponent("ScheduleViewLoader")!
  const _component_ModalInnerSelectPossibleDates = _resolveComponent("ModalInnerSelectPossibleDates")!
  const _component_PossibleDatesWithCalendarTable = _resolveComponent("PossibleDatesWithCalendarTable")!
  const _component_FormContent = _resolveComponent("FormContent")!
  const _component_FixScheduleSmallModal = _resolveComponent("FixScheduleSmallModal")!
  const _component_FixScheduleModal = _resolveComponent("FixScheduleModal")!
  const _component_ModalCancelAppointment = _resolveComponent("ModalCancelAppointment")!
  const _component_ModalRequestAdditionalPossibleDates = _resolveComponent("ModalRequestAdditionalPossibleDates")!
  const _component_ModalEditAppointment = _resolveComponent("ModalEditAppointment")!

  return (_ctx.room && _ctx.appo && _ctx.pdm)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showMainContent())
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              class: _normalizeClass(`ScheduleCalendarContent with_white_bg ${_ctx.rm.designType() == `normal` ? `` : `floatRightContent ofs`} ${
                _ctx.isSP ? `spContent` : ``
            }`),
              style: _normalizeStyle({
                minWidth: !_ctx.currentPossibleDates && !_ctx.isSP && _ctx.rm.designType() == `normal` ? '700px' : '',
            })
            }, [
              _createVNode(_component_ScheduleMainHeaderButton, {
                appo: _ctx.appo,
                type: _ctx.type,
                room: _ctx.room,
                appoStatus: _ctx.appoStatus,
                onRescheduleWithoutChoice: _ctx.rescheduleWithoutChoice,
                onClickReschedule: _ctx.clickReschedule,
                onShowCancelModal: _ctx.showCancelModal
              }, null, 8, ["appo", "type", "room", "appoStatus", "onRescheduleWithoutChoice", "onClickReschedule", "onShowCancelModal"]),
              (_ctx.type == `editable` && _ctx.astag)
                ? (_openBlock(), _createBlock(_component_ScheduleMainEditableCalendarHeaderContent, {
                    key: 0,
                    onEditAstag: _ctx.editAstag,
                    onEditAppoInfo: _ctx.editAppoInfo,
                    gettingPds: _ctx.gettingPds,
                    ref: "EditableCalendarHeader"
                  }, null, 8, ["onEditAstag", "onEditAppoInfo", "gettingPds"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ScheduleMainHeaderTitle, {
                appo: _ctx.appo,
                type: _ctx.type
              }, null, 8, ["appo", "type"]),
              _hoisted_2,
              _createVNode(_component_InstantRoomContent, { onClickInstantButton: _ctx.clickInstantButton }, null, 8, ["onClickInstantButton"]),
              ([_ctx.Appointment.statusCancel].includes(_ctx.appo.status) && !_ctx.pdm.isSuspend)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "centered mt20",
                    style: _normalizeStyle({
                    top: _ctx.isSP ? '80px' : '',
                })
                  }, [
                    (_ctx.room.room_setting.can_change_appointment_from_other)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _hoisted_4,
                          _createElementVNode("p", {
                            class: "pointer centered circle_button blueAround fs16 rad8 fw600",
                            style: {"line-height":"40px","margin-top":"25px","padding":"4px 30px"},
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewAppo && _ctx.addNewAppo(...args)))
                          }, " 新規の日程調整を開始 ")
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                  ], 4))
                : _createCommentVNode("", true),
              (_ctx.appo && _ctx.selectingDates)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_SelectableLocations, {
                      onSelectLoctag: _ctx.selectLoctag,
                      appo: _ctx.appo
                    }, null, 8, ["onSelectLoctag", "appo"]),
                    _createVNode(_component_SelectableGroups, {
                      onSelectMag: _ctx.selectMag,
                      appo: _ctx.appo
                    }, null, 8, ["onSelectMag", "appo"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.appo.status == 10 && _ctx.pdm.displayType != `reschedule`)
                ? (_openBlock(), _createBlock(_component_ScheduleMainFixedAppoContent, {
                    key: 3,
                    appo: _ctx.appo,
                    room: _ctx.room
                  }, null, 8, ["appo", "room"]))
                : _createCommentVNode("", true),
              _hoisted_10,
              (_ctx.appo.status == 10 && _ctx.pdm.displayType != `reschedule`)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 4,
                    class: _normalizeClass(`w100 ${_ctx.isSP ? `` : `ml20`}`),
                    style: {"margin-top":"40px"}
                  }, [
                    (!_ctx.isInstantRoom)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t(`title.register_calendar`)), 1),
                          _createVNode(_component_CalendarActionLargeButtons, { appo: _ctx.appo }, null, 8, ["appo"]),
                          _hoisted_13
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                : (_ctx.appo.status == -1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                  : (!_ctx.currentPossibleDates)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_ScheduleViewLoader, { loadingMessage: `最新の日程を取得しています` })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        (_ctx.showSuggestedView())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              (_ctx.Util.isEmbeds())
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createTextVNode(" 日程を提案済みです。"),
                                    _hoisted_19,
                                    _createTextVNode("お相手から調整のアクションがあるまでしばらくお待ち下さい。 ")
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    false
                                      ? (_openBlock(), _createElementBlock("section", {
                                          key: 0,
                                          class: _normalizeClass(`${_ctx.isSP ? `centered` : `fr`} fs13 label skyblue pointer`),
                                          style: _normalizeStyle({
                                borderBottom: `dotted 2px #2c96ff`,
                                lineHeight: `18px`,
                                margin: _ctx.isSP ? `10px 0` : ``,
                            }),
                                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reselectSuggestDates()))
                                        }, [
                                          _createElementVNode("img", {
                                            src: _ctx.$getAssetImageUrl(`/assets/icons/editPen.png`),
                                            width: "14",
                                            height: "14",
                                            style: {"margin-top":"-3px"}
                                          }, null, 8, _hoisted_21),
                                          _createTextVNode(" 提案した候補日時を再選択する ")
                                        ], 6))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", {
                                      class: _normalizeClass(`fw600 circle_button blueAround pointer centered rad10 ${
                                _ctx.isSP ? `w100 mb10` : `fr ml20 mr20`
                            } with_white_bg`),
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reselectSuggestDates()))
                                    }, [
                                      _createElementVNode("p", _hoisted_22, [
                                        _createElementVNode("img", {
                                          src: _ctx.$getAssetImageUrl(`/assets/icons/vote_r.png`),
                                          width: "19",
                                          height: "20",
                                          style: {"margin-top":"-3px"}
                                        }, null, 8, _hoisted_23),
                                        _createTextVNode(" 提案した日程を変更する ")
                                      ])
                                    ], 2),
                                    _createTextVNode(" 日程を提案済みです。"),
                                    _hoisted_24,
                                    _createTextVNode("お相手から調整のアクションがあるまでしばらくお待ち下さい。 ")
                                  ]))
                            ]))
                          : ([`possibles`, `reschedule`].includes(_ctx.pdm.displayType))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                (!_ctx.currentPossibleDates)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                      _createVNode(_component_ScheduleViewLoader, {
                                        loadingMessage: `最新の日程を取得しています`,
                                        style: {"min-width":"660px"}
                                      })
                                    ]))
                                  : (_ctx.Util.isPresent(_ctx.currentPossibleDates))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        (_ctx.pdm.displayType == `reschedule` && _ctx.appoStatus == _ctx.Appointment.typeReschedule)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                              _createTextVNode(_toDisplayString(_ctx.$t(`schedule.please_select_other_date`)) + " ", 1),
                                              _hoisted_29
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.pdm.showSuggestPossibleTable())
                                          ? (_openBlock(), _createBlock(_component_ModalInnerSelectPossibleDates, {
                                              key: 1,
                                              ref: "SelectPossibleDatesContent",
                                              room: _ctx.room,
                                              getPossiblesWithMonth: _ctx.getPossiblesWithMonth,
                                              getPossiblesWithWeek: _ctx.getPossiblesWithWeek,
                                              loading: _ctx.loading || _ctx.gettingPds,
                                              appoStatus: _ctx.appoStatus,
                                              onSelectPossibleDates: _ctx.selectPossibleDates,
                                              onSelectPossibleDatesFromReschedule: _ctx.selectPossibleDatesFromReschedule,
                                              onChangeLoading: _ctx.changeLoading
                                            }, null, 8, ["room", "getPossiblesWithMonth", "getPossiblesWithWeek", "loading", "appoStatus", "onSelectPossibleDates", "onSelectPossibleDatesFromReschedule", "onChangeLoading"]))
                                          : (_openBlock(), _createBlock(_component_PossibleDatesWithCalendarTable, {
                                              key: 2,
                                              idprefix: `top`,
                                              astag: _ctx.astag,
                                              showConfirmButton: true,
                                              useSelectbox: false,
                                              getPossiblesWithMonth: _ctx.getPossiblesWithMonth,
                                              getPossiblesWithWeek: _ctx.getPossiblesWithWeek,
                                              loading: _ctx.loading || _ctx.gettingPds,
                                              onConfirmFixSchedule: _ctx.confirmFixSchedule,
                                              calendarShowType: _ctx.calendarShowType()
                                            }, null, 8, ["astag", "getPossiblesWithMonth", "getPossiblesWithWeek", "loading", "onConfirmFixSchedule", "calendarShowType"]))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                        _createTextVNode(" 共有された調整カレンダーから、現在の日程で候補が見つかりませんでした。 "),
                                        (_ctx.Util.isRoomSettingsPreview())
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                              _hoisted_32,
                                              _createElementVNode("section", {
                                                class: "pointer centered circle_button blueAround fs16 fl",
                                                style: {"width":"220px","border-radius":"8px","height":"44px","padding":"9px 8px"},
                                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.editCalendar && _ctx.editCalendar(...args)))
                                              }, [
                                                _createElementVNode("img", {
                                                  src: _ctx.$getAssetImageUrl(`/assets/icons/calendar_himekuri_grey.png`),
                                                  width: "23",
                                                  height: "23",
                                                  style: {"margin-top":"0px"}
                                                }, null, 8, _hoisted_33),
                                                _hoisted_34
                                              ]),
                                              _hoisted_35
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                              ]))
                            : _createCommentVNode("", true)
                      ])),
              _hoisted_36
            ], 6))
          : ([`form`, `form_with_fix`].includes(this.currentStep))
            ? (_openBlock(), _createElementBlock("section", {
                key: 1,
                class: _normalizeClass(`ScheduleCalendarContent with_white_bg ofs ${_ctx.rm.designType() == `normal` ? `` : `floatRightContent`} ${
                _ctx.isSP ? `spContent` : ``
            }`)
              }, [
                _createVNode(_component_FormContent, {
                  room: _ctx.instantRoom ? _ctx.instantRoom : _ctx.room,
                  currentStep: _ctx.currentStep,
                  additionalParams: _ctx.additionalParams,
                  onCompleteForm: _ctx.completeForm,
                  onChangeDate: _ctx.changeDate,
                  onSkipForm: _ctx.skipForm,
                  onAutoSendForm: _ctx.autoSendForm,
                  loadingFormSending: _ctx.loadingFormSending
                }, null, 8, ["room", "currentStep", "additionalParams", "onCompleteForm", "onChangeDate", "onSkipForm", "onAutoSendForm", "loadingFormSending"])
              ], 2))
            : _createCommentVNode("", true),
        _createVNode(_component_FixScheduleSmallModal, {
          ref: "fixScheduleSmallModal",
          room: _ctx.room,
          from: `schedule`,
          onActionAfterFixed: _ctx.actionAfterFixed,
          onRescheduledRoom: _ctx.rescheduledRoom,
          getNextStep: _ctx.getNextStep,
          onCallBeforeFix: _ctx.callBeforeFix
        }, null, 8, ["room", "onActionAfterFixed", "onRescheduledRoom", "getNextStep", "onCallBeforeFix"]),
        _createVNode(_component_FixScheduleModal, {
          ref: "fixScheduleModal",
          room: _ctx.room,
          from: `schedule`,
          getNextStep: _ctx.getNextStep,
          onCallBeforeFix: _ctx.callBeforeFix,
          onActionAfterFixed: _ctx.actionAfterFixed,
          onRescheduledRoom: _ctx.rescheduledRoom
        }, null, 8, ["room", "getNextStep", "onCallBeforeFix", "onActionAfterFixed", "onRescheduledRoom"]),
        _createVNode(_component_ModalCancelAppointment, {
          selectedMessageRoom: _ctx.room,
          appo: _ctx.appo,
          appoStatus: _ctx.appoStatus,
          onUpdatedVotedRooms: _ctx.updatedVotedRooms,
          onRescheduledRoom: _ctx.rescheduledRoom
        }, null, 8, ["selectedMessageRoom", "appo", "appoStatus", "onUpdatedVotedRooms", "onRescheduledRoom"]),
        _createVNode(_component_ModalRequestAdditionalPossibleDates),
        (_ctx.isSP)
          ? (_openBlock(), _createBlock(_component_ModalEditAppointment, {
              key: 2,
              appoStatus: _ctx.appoStatus,
              onHide: _ctx.hideEditAppointmentModal
            }, null, 8, ["appoStatus", "onHide"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}